module.exports = __webpack_public_path__ + "img/Logo(ko)_Light.dd076e12.svg";